<template>
  <v-row no-gutters>
    <v-col>
      <div id="manager-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card tile :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'">
          <PageHeader title="Yöneticiler" :headerIcons="icons.mdiAccountTie" :isAction="true">
            <template #action>
              <v-dialog
                v-model="addEditdialog"
                max-width="500px"
                class="elevation-0"
                scrollable
                :persistent="dialogLoading"
                overlay-opacity="0.6"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="text-capitalize"
                    color="secondary"
                    depressed
                    rounded
                  >
                    Yönetici Ekle
                  </v-btn>
                </template>
                <v-card
                  rounded="xl"
                  flat
                  :disabled="dialogLoading"
                  :class="{
                    'scrollable-card': !isScroll,
                    'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
                    'scrollable-not-card': !isScroll && arrivedState.bottom,
                  }"
                >
                  <v-card-title class="grey">
                    <h4 class="text-body-1 text-sm-h6 font-weight-bold">
                      {{ addEditFormTitle }}
                    </h4>

                    <v-spacer />

                    <v-btn
                      color="error"
                      small
                      outlined
                      class="mx-4 text-capitalize"
                      rounded
                      v-if="editedIndex > -1"
                      :loading="deleteLoading"
                      @click="deleteItem()"
                    >
                      <v-icon left>{{ icons.mdiTrashCan }}</v-icon> Sil
                    </v-btn>
                    <v-btn
                      v-if="$vuetify.breakpoint.smAndUp"
                      rounded
                      small
                      depressed
                      color="chip"
                      class="text-capitalize"
                      @click="closeItem"
                    >
                      <v-icon left>{{ icons.mdiClose }}</v-icon>
                      Kapat
                    </v-btn>
                    <v-icon v-else small @click="closeItem">{{ icons.mdiClose }}</v-icon>
                  </v-card-title>

                  <v-divider />
                  <v-card-text
                    ref="scrollableEl"
                    class="pa-0 pa-sm-3 pb-0 pt-3"
                    style="height: 80dvh"
                    :style="
                      !$vuetify.breakpoint.smAndUp ? 'max-height: 485px' : 'max-height: 425px'
                    "
                  >
                    <validation-observer ref="form">
                      <v-container class="pb-0">
                        <v-row>
                          <v-col cols="12" md="12">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-select
                                v-model="editedItem.profile_id"
                                :items="profileList"
                                label="Profil"
                                rounded
                                filled
                                hide-details
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.adsoyad"
                                label="Ad Soyad"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required|email"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.mail"
                                label="E-Posta"
                                type="email"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              :rules="{ required: true, regex: /^[a-zA-Z0-9._]*$/ }"
                            >
                              <v-text-field
                                :error-messages="errors"
                                v-model="editedItem.username"
                                label="Kullanıcı Adı"
                                rounded
                                filled
                                hide-details
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              :rules="`${editedIndex > -1 ? 'alpha_num' : 'required|alpha_num'}`"
                            >
                              <v-text-field
                                @click:append="showPassword = !showPassword"
                                :error-messages="errors"
                                v-model="editedItem.sifre"
                                :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
                                :type="showPassword ? 'text' : 'password'"
                                :label="editedIndex > -1 ? '' : 'Şifre'"
                                :placeholder="
                                  editedIndex > -1 ? 'Şifre değiştirmek için doldurun' : ''
                                "
                                autocomplete="new-password"
                                rounded
                                filled
                                hide-details
                            /></validation-provider>
                          </v-col>
                          <v-col v-if="!$vuetify.breakpoint.smAndUp">
                            <v-switch
                              v-model="editedItem.aktif"
                              class="mt-0 pt-0 ml-3"
                              inset
                              color="secondary"
                              :label="
                                editedItem.aktif ? 'Yönetici Durumu Aktif' : 'Yönetici Durumu Pasif'
                              "
                            ></v-switch>
                          </v-col>
                        </v-row>
                      </v-container>
                    </validation-observer>
                  </v-card-text>
                  <v-card-actions class="pa-0 pa-sm-3 pt-0">
                    <v-container class="pt-0" style="z-index: 2">
                      <v-row align="center">
                        <v-col cols="12" :sm="editedIndex > -1 ? 7 : 12">
                          <v-btn
                            color="secondary"
                            depressed
                            rounded
                            block
                            x-large
                            :loading="saveLoading"
                            class="text-capitalize"
                            @click="saveItem()"
                          >
                            {{ editedIndex > -1 ? "Güncelle" : "Kaydet" }}
                          </v-btn>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="5"
                          v-if="editedIndex > -1 && $vuetify.breakpoint.smAndUp"
                        >
                          <v-switch
                            v-model="editedItem.aktif"
                            hide-details
                            class="mt-0 pt-0 ml-3"
                            inset
                            color="secondary"
                            :label="editedItem.aktif ? 'Aktif' : 'Pasif'"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </PageHeader>

          <v-data-table
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            loader-height="2"
            fixed-header
            hide-default-footer
            :height="pageStore.tableHeight"
            :mobile-breakpoint="100"
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :items-per-page="20"
          >
            <!-- Load More -->
            <template v-slot:body.append v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!--  Arama -->
            <template v-slot:body.prepend>
              <tr class="data-table-body-search">
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchStatus"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Aktif', value: '1' },
                      { text: 'Pasif', value: '0' },
                    ]"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchProfil"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="profileList"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchUsername"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchFullname"
                    :prepend-inner-icon="icons.mdiMagnify"
                    clearable
                    persistent-placeholder
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  ></v-text-field>
                </td>
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <template #[`item.aktif`]="{ item }">
              <v-chip
                label
                outlined
                class="d-flex justify-center"
                :color="item.aktif ? 'success' : 'warning'"
              >
                <span style="font-size: 11px !important; letter-spacing: 0.5px">
                  {{ item.aktif ? "Aktif" : "Pasif" }}</span
                >
              </v-chip>
            </template>

            <template #[`item.profile_id`]="{ item }">
              <v-chip label color="chip" class="d-flex justify-center">
                <div
                  class="text-truncate text-uppercase"
                  style="
                    width: 120px !important;
                    text-align: center;
                    font-size: 10px !important;
                    letter-spacing: 1.25px;
                    color: azure;
                  "
                >
                  {{ item.profilTxt }}
                </div>
              </v-chip>
            </template>

            <template #[`item.username`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="text-truncate"
                  style="
                    width: 120px !important;
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  {{ item.username }}
                </div>
              </v-chip>
            </template>

            <template #[`item.adsoyad`]="{ item }">
              <div class="d-flex align-center">
                <div>
                  <div class="text-subtitle-2 white--text text-capitalize" style="line-height: 1.2">
                    {{ item.adsoyad }}
                  </div>
                  <div class="text-caption text--disabled" style="line-height: 1.2">
                    {{ item.mail }}
                  </div>
                </div>
              </div>
            </template>

            <!-- Son Giriş Tarihi -->
            <template #[`item.son_giris`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                    <div
                      class="text-truncate d-flex align-center"
                      style="
                        width: 140px !important;
                        text-align: center;
                        font-size: 11px !important;
                        letter-spacing: 0.5px;
                        color: azure;
                      "
                    >
                      <v-icon color="" small class="mr-2">
                        {{ icons.mdiCalendarClock }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.son_giris | moment("DD.MM.YYYY ") }}
                      </div>

                      <span> - {{ item.son_giris | moment("HH:mm") }}</span>
                    </div>
                  </v-chip>
                </template>
                <div>
                  <timeago :datetime="item.son_giris"></timeago>
                </div>
              </v-tooltip>
            </template>

            <template #item.actions="{ item }">
              <v-btn
                depressed
                block
                style="height: 32px !important"
                color="chip"
                class="text-capitalize ml-2"
                @click="editItem(item)"
              >
                Düzenle
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import { onUnmounted, computed, watch, onMounted, ref } from "vue-demi";

// Pinia
import { usePageStore } from "@/stores/pageHeader";

// Plugin
import { useToast } from "vue-toastification/composition";

// Unit
import { useDebounceFn, useScroll, useResizeObserver } from "@vueuse/core";
import { postData } from "@utils";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";

// Icons
import {
  mdiCamera,
  mdiCameraOff,
  mdiAccountTie,
  mdiMagnify,
  mdiUpload,
  mdiTrashCan,
  mdiCalendarClock,
  mdiClose,
  mdiEye,
  mdiEyeOff,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const pageStore = usePageStore();

    const pageSettings = () => {
      pageStore.pageTitle = "Yöneticiler";
      pageStore.pageIcon = mdiAccountTie;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = true;

      pageStore.downloadHeader = {
        Durum: "aktif",
        Profil: "profile_id",
        "Kullanıcı Adı": "username",
        "Ad Soyad": "username",
        "Son Giriş Zamanı": "son_giris",
      };
    };
    const toast = useToast();

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);
    const tableColumns = ref([
      {
        text: "Durum",
        value: "aktif",
        width: "100px",
        sortable: false,
      },
      {
        text: "Profil",
        value: "profile_id",
        width: "200px",
        sortable: false,
      },
      {
        text: "Kullanıcı Adı",
        value: "username",
        width: "200px",
      },
      {
        text: "Ad Soyad",
        value: "adsoyad",
        sortable: false,
      },

      {
        text: "Son Giriş Zamanı",
        value: "son_giris",
        width: "150px",
      },

      {
        text: "",
        value: "actions",
        align: "right pl-0",
        width: "150",
        sortable: false,
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableSearchStatus = ref("");
    const tableSearchProfil = ref("");
    const tableSearchUsername = ref("");
    const tableSearchFullname = ref("");
    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    const tableEmptying = () => {
      loadMoreLoading.value = false;
      tableLoading.value = true;
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableItems.value = [];
    };

    watch([tableSearchStatus, tableSearchProfil, tableSearchUsername, tableSearchFullname], () => {
      tableEmptying();

      debouncedTableSearch();
    });

    const dialogLoading = ref(false);
    const editedIndex = ref(-1);
    const editedItem = ref({
      aktif: true,
      adsoyad: "",
      username: "",
      mail: "",
      profile_id: "",
      sifre: "",
      sifret: "",
    });

    const defaultItem = JSON.parse(JSON.stringify(editedItem.value));

    const profileList = ref([]);
    const profileFetch = async () => {
      try {
        const data = await postData({
          method: "getProfileList",
        });
        profileList.value = data.detail.map((item) => {
          return {
            value: item.profile_id,
            text: item.profile_name,
          };
        });
      } catch (e) {
        // API hataya girdi
        toast.error(`Hata ${e}`);
      }
    };

    // API İstek
    const tableFetch = async () => {
      tableLoading.value = true;

      postData({
        method: "getAdminUsers",
        options: JSON.stringify(tableOptions.value),
        search: JSON.stringify({
          is_active: tableSearchStatus.value,
          profile: tableSearchProfil.value,
          uname: tableSearchUsername.value,
          displayname: tableSearchFullname.value,
          email: tableSearchFullname.value,
        }),
      })
        .then(async (response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          if (profileList.value.length === 0) {
            await profileFetch();
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.pagination.totalCount);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.result.map((item) => {
            tableItems.value.push({
              uid: item.uid,
              aktif: item.aktif,
              profile_id: item.profile_id,
              profilTxt:
                profileList.value.find((el) => el.value === item.profile_id)?.text || "Tanımsız",
              username: item.username,
              adsoyad: item.adsoyad,
              mail: item.mail,
              son_giris: item.son_giris,
            });
          });
          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
        });
    };

    // Ekle / Düzenle / Sil
    const form = ref(null);

    const showPassword = ref(false);
    const addEditdialog = ref(false);
    const deleteLoading = ref(false);
    const saveLoading = ref(false);
    const addEditFormTitle = computed(() => {
      return editedIndex.value === -1 ? "Yönetici Ekle" : "Düzenleme";
    });

    const editItem = (item) => {
      editedIndex.value = tableItems.value.indexOf(item);
      editedItem.value = Object.assign({}, item);
      addEditdialog.value = true;
    };

    const saveItem = async () => {
      const isValid = await form.value.validate();
      if (!isValid) {
        toast.error(`Lütfen kırımızı alanları doldurun`, { position: "bottom-center" });

        return;
      }
      dialogLoading.value = true;

      delete editedItem.value.son_giris;
      delete editedItem.value.profilTxt;

      try {
        saveLoading.value = true;
        if (editedIndex.value > -1) {
          if (editedItem.value.sifre) {
            editedItem.value.sifret = editedItem.value.sifre;
            editedItem.value.sifre_check = 1;
          }
          editedItem.value.mode2 = "memberUpdate";

          const response = await postData({
            method: "insertMember",
            ...editedItem.value,
          });
          if (response.error) {
            throw new Error(response.msg);
          }

          toast.info(`"${editedItem.value.adsoyad}" Yöneticisi güncellendi`);
        } else {
          editedItem.value.sifret = editedItem.value.sifre;

          const response = await postData({
            method: "insertMember",
            ...editedItem.value,
          });
          if (response.error) {
            throw new Error(response.msg);
          }

          toast.success(`"${editedItem.value.adsoyad}" Yöneticisi eklendi`);
        }
        tableEmptying();
        tableFetch();
      } catch (e) {
        toast.error(`Hata ${e}`, { position: "bottom-center" });
        return;
      } finally {
        closeItem();
      }
    };

    const deleteItem = async () => {
      Vue.swal({
        title: "Emin misin",
        html: `<strong>"${editedItem.value.adsoyad}"</strong><br>yönetici silinsin mi`,
        icon: "warning",
        width: "350px",
        background: "#FF4C51",
        showCancelButton: true,
        confirmButtonColor: "#cc3d41",
        confirmButtonText: "Evet",
        cancelButtonText: "Vazgeç",
        cancelButtonColor: "#FF4C51",
      }).then(async (result) => {
        if (result.isConfirmed) {
          dialogLoading.value = true;
          deleteLoading.value = true;
          try {
            const response = await postData({
              method: "deleteMember",
              id: editedItem.value.uid,
            });
            if (response.error) {
              throw new Error(response.msg);
            }
            toast.warning(`"${editedItem.value.adsoyad}" yönetici silindi`);

            tableEmptying();
            tableFetch();
          } catch (e) {
            toast.error(`Hata ${e}`, { position: "bottom-center" });
          } finally {
            closeItem();
          }
        }
      });
    };

    const closeItem = () => {
      dialogLoading.value = false;
      deleteLoading.value = false;
      saveLoading.value = false;
      addEditdialog.value = false;
      editedItem.value = Object.assign({}, defaultItem);
      editedIndex.value = -1;
    };

    const scrollableEl = ref(null);

    // Kaydırma çubuğu
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);
    onMounted(() => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
    });

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value = scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    watch(
      () => addEditdialog,
      (val) => {
        if (!val) {
          form.value.reset();
        } else {
        }
      }
    );

    onMounted(async () => {
      pageSettings();
      // Yöneticiler Çekiliyor
      tableFetch();
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    return {
      profileList,
      pageStore,

      // Table
      tableFetch,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,

      tableOptions,

      // Table Search
      tableColumns,
      tableSearchStatus,
      tableSearchProfil,
      tableSearchUsername,
      tableSearchFullname,

      // Ürün Ekle / Düzenle / Sil
      form,
      dialogLoading,
      deleteLoading,
      saveLoading,
      addEditFormTitle,
      addEditdialog,
      editItem,
      deleteItem,
      closeItem,
      saveItem,
      editedItem,
      editedIndex,
      scrollableEl,
      showPassword,
      isScroll,
      arrivedState,

      // icons
      icons: {
        mdiCamera,
        mdiCameraOff,
        mdiAccountTie,
        mdiClose,
        mdiMagnify,
        mdiUpload,
        mdiTrashCan,
        mdiCalendarClock,

        mdiEye,
        mdiEyeOff,
      },
    };
  },
};
</script>
